module.exports = __webpack_public_path__ + "img/bottone_lista_fornitori_consorzio.96273be5.png";